// Minimal client-side auth helpers using SHA-256 hashing
export async function hashPassword(password) {
  if (!password) return '';
  const enc = new TextEncoder();
  const data = enc.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

export async function verifyPassword(password, hash) {
  if (!password || !hash) return false;
  const h = await hashPassword(password);
  return h === hash;
}

export function loadAuthConfig() {
  try {
    const raw = localStorage.getItem('my-dashboard-auth');
    if (!raw) return { enabled: false, users: [] };
    return JSON.parse(raw);
  } catch (e) { return { enabled: false, users: [] }; }
}

export function saveAuthConfig(cfg) {
  try { localStorage.setItem('my-dashboard-auth', JSON.stringify(cfg)); } catch (e) { console.warn('Failed to save auth config', e); }
}

// Load or initialize default users (ymezaber/madara42 + guest account)
export function loadUsers() {
  const cfg = loadAuthConfig();
  if (!cfg.users || cfg.users.length === 0) {
    // Default: admin (ymezaber) and guest account
    return [
      { username: 'ymezaber', hash: 'default-madara', role: 'admin', rights: ['addSite', 'removeSite', 'editSite', 'manageUsers'] },
      { username: 'Invité', hash: 'guest', role: 'guest', rights: ['viewSites'] }
    ];
  }
  return cfg.users;
}

// Save users list
export async function saveUsers(users) {
  const cfg = loadAuthConfig();
  cfg.users = users;
  cfg.enabled = users.length > 0;
  saveAuthConfig(cfg);
}

// Verify against users list (special case for hardcoded default)
export async function verifyUser(username, password) {
  const users = loadUsers();
  const user = users.find(u => u.username === username);
  if (!user) return false;
  
  // Special case: default user ymezaber with password madara42
  if (username === 'ymezaber' && user.hash === 'default-madara' && password === 'madara42') {
    return true;
  }

  // Special case: guest account (no password)
  if (username === 'Invité' && user.hash === 'guest' && password === '') {
    return true;
  }
  
  // Otherwise verify hash
  return await verifyPassword(password, user.hash);
}

// Get user rights for current logged-in user
export function getUserRights(username) {
  const users = loadUsers();
  const user = users.find(u => u.username === username);
  return user ? (user.rights || []) : [];
}

// Check if user has a specific right
export function hasRight(username, right) {
  const rights = getUserRights(username);
  return rights.includes(right);
}
